<template>
	<div>
		<!--  学校详情-->
		<div class="expert">
			<!-- <Breadcrumb></Breadcrumb> -->
			<!-- <div style="color: #222222;">111</div> -->
			<!--          <div class="check pad-16">
                <div class="all-check">
                    <div class="check-1">
                        <p class="check-p">省份(2)</p>
                        <div class="check-1-p">
                            <p v-for="(ite,inde) in provice" :key="inde">
                                {{ite}}
                            </p>
                        </div>
                    </div>
                    <div class="check-1 jus-bet" style="margin-bottom: 0;">
                        <div class="check-1">
                            <p class="check-p">学段(2)</p>
                            <div class="check-1-p">
                                <p v-for="(ite,inde) in school" :key="inde">
                                    {{ite}}
                                </p>
                            </div>
                        </div>
                        <div class="check-1 align-1">
                            <img src="../../assets/expert/chongzhi.png" alt="" style="width: 16px;height: 16px;">
                            <p>重置</p>
                        </div>
                    </div>
                </div>
            </div> -->
			<div class="boxshow">
				<div class="experts flex-1 pad-16 jus-bet">
					<div class="flex-1 jus-bet">
						<div class="left-icon"></div>
						<p>名校风采</p>
					</div>
				</div>
				<div class="pad-16 col-22">
					<div style="padding-bottom: 24px;border-bottom: 1px solid #EFEFEF;display: flex;">
						<img :src="details.coverImg" alt="" class="hed-img">
						<div>
							<div class="flex-1 just-bet mb-8">
								<p class="name-1">{{details.schoolName}}</p>
								<!-- <img :src="item.img" alt="" class="sex-img"> -->
								<!-- <img src="/src/assets/expert/nv.png" alt=""> -->
							</div>
							<div class="flex-1 just-bet" style="align-items: baseline;">
								<p class="name-2">学校简介:</p>
								<p class="name-3">{{details.introduction}}
								</p>
							</div>
						</div>
					</div>
					<div class="ql-editor">
						<div style="margin-top: 24px;" v-html="details.content"></div>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getDetail
	} from '@/api/famous/api.js';
	export default {
		components: {},
		data() {
			return {
				details: ''
			}
		},
		created() {

		},
		mounted() {
			this.getDeatils(this.$route.params.id);
		},
		methods: {
			getDeatils(id) {
				getDetail({
						id: id
					}).then(res => {
						this.details = res.data;
						this.details.content = this.details.content.replace(/<img/g,
							'<img mode="widthFix" style="width: 98%"');
					})
					.catch(error => {

					});
			},

		}
	}
</script>

<style scoped>
	.expert {
		/* padding: 0 19%; */
		/* margin-bottom: 100px; */
	}

	.boxshow {
		box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.pad-16 {
		padding: 16px;
	}

	.flex-1 {
		display: flex;
		align-items: center;
		/* justify-content: space-between; */
	}

	.experts {
		margin-top: 16px;

	}

	.experts p {
		font-size: 20px;
		color: #222222;
		font-family: font5;
		margin-left: 10px;
	}

	.left-icon {
		width: 6px;
		height: 20px;
		background: #3377FF;
		border-radius: 18px;
	}

	.check {
		/* width: 100%; */
		/* height: 352px; */
		background: #FAFAFA;
		border-radius: 4px 4px 4px 4px;
		color: #222222;
		margin-top: 16px;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.align-1 {
		align-items: center;
	}

	.shouqi {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		color: #666666;
	}

	.col-22 {
		color: #222222;

	}

	.hed-img {
		width: 288px;
		height: 173px;
		margin-right: 16px;
		border-radius: 8px;
	}

	.sex-img {
		width: 14px;
		height: 14px;
	}

	.mb-8 {
		margin-bottom: 8px;
	}

	.name-1 {
		font-size: 20px;
		font-family: font5;
		padding-right: 9px;
		/* padding-top: 35px; */
	}

	.name-2 {
		color: #999999;
		font-size: 14px;
		font-family: font3;
		white-space: nowrap;
		padding-right: 8px;
	}

	.name-3 {
		font-size: 14px;
		font-family: font3;
		font-weight: normal;
	}

	/deep/.el-pagination {
		text-align: center;
	}

	.footers {
		margin-top: 25px !important;
	}
</style>